"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartFavEmptyIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var withSVGIcon_1 = require("./withSVGIcon");
var Icon = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: jsx_runtime_1.jsx("path", { d: "M17 4.81143C17 9.033 12.3513 13.0609 9.56399 14.9609C9.22621 15.1911 8.78205 15.1781 8.45256 14.9361C5.66718 12.8908 1 9.04136 1 4.81143C1 2.52225 2.9401 0.666504 5.33333 0.666504C6.87718 0.666504 8.23246 1.43875 9 2.60143C9.76754 1.43875 11.1228 0.666504 12.6667 0.666504C15.0599 0.666504 17 2.52225 17 4.81143Z", stroke: "currentColor", strokeWidth: strokeWidth }, void 0) }, void 0));
};
exports.HeartFavEmptyIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 18 16' });
//# sourceMappingURL=HeartFavEmptyIcon.js.map